// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"20cc6983","455":"e7f8d037","977":"ac534372"}[chunkId] + ".chunk.js";
};